export const DAILY_DAYS_OF_WEEK = [
  { key: 0, label: 'Mon' },
  { key: 1, label: 'Tue' },
  { key: 2, label: 'Wed' },
  { key: 3, label: 'Thu' },
  { key: 4, label: 'Fri' },
  { key: 5, label: 'Sat' },
  { key: 6, label: 'Sun' },
];
